import $ from 'jquery';
import 'jquery-zoom';

export default class Zoom {
    DURATION = 120;

    /**
     * @param {import('../ThemeBase').default} theme
     * @param {HTMLElement} element
     */
    constructor(theme, element) {
      this.theme = theme;
      this.element = element;
      this.$element = $(element);
      this.img = element.querySelector('img');
      this.timer = null;

      const self = this;
      // @ts-ignore
      this.$element.zoom({
        url: this.img.dataset.zoomImg || this.img.src,
        touch: false,
        duration: this.DURATION,
        onZoomIn: function () { self.onZoomIn(this); },
        onZoomOut: this.onZoomOut,
      });
    }

    onZoomIn = (img) =>  {
      // Hide zoomed image when it's smaller then parent div,
      // it would just move but there won't be any zoom
      if (this.$element.width() >= $(img).width()) {
        this.$element.find('.zoomImg').addClass('hide');
        return;
      } else {
        this.$element.find('.zoomImg').removeClass('hide');
      }

      // Hide image when zoomed image is hovered - to prevent
      // both images visible when the image is too small
      this.timer = setTimeout(() => {
        this.img.classList.add('product-image-hidden');
        this.timer = null;
      }, this.DURATION);
    }

    onZoomOut = () => {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.img.classList.remove('product-image-hidden');
    }

    destroy = () => {
      this.$element.trigger('zoom.destroy');
    }
}
